var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomisations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.333 6.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.06 12.03v6.667H4.726a3.333 3.333 0 0 1 0-6.667H20.06z",
    stroke: "#212121",
    strokeWidth: 1.167,
    fill: "#FFF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.2 2.134 4.713 4.714L7.071 17.69a3.333 3.333 0 1 1-4.714-4.714L13.199 2.134z",
    stroke: "#212121",
    strokeWidth: 1.167,
    fill: "#FFF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38 0h6.667v15.333a3.333 3.333 0 1 1-6.666 0V0z",
    stroke: "#212121",
    strokeWidth: 1.167,
    fill: "#FFF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#212121",
    cx: 4.714,
    cy: 15.333,
    r: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 1.167,
    strokeLinejoin: "round",
    d: "M1.381 0h6.667v3.333H1.381zM1.381 3.333h6.667v3.333H1.381zM1.381 6.667h6.667V10H1.381z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomisations);
export default __webpack_public_path__ + "static/media/customisations.5599c6cad3589ac5b478e2d20940b6ef.svg";
export { ForwardRef as ReactComponent };